import { memo } from 'react';

import AddIconSVG from '@/assets/exported-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IExportedIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AddIconSVG} {...props} />;

export const ExportedIcon = memo(IExportedIcon) as typeof IExportedIcon;
